export enum TOKEN_NAME_CONSTANT {
  TOKEN = 'token',
  REFRESH_TOKEN = 'refreshToken',
}

export const ALERT_BOTTOM_PRESCRIPTION = {
  errorPromo: {
    text: 'This promo code can’t be applied for this order.',
    actionText: 'Remove',
  },
  errorPaymentMethod: {
    text:
      "User is not registered as the insured's data. This payment method can't be applied for this order.",
    actionText: 'OK',
  },
};
